import React, { FC } from 'react';
import { DATA_HOOK } from '../../ListItemAction.constants';
import { classes, st } from '../../ListItemAction.st.css';
import { ListItemActionProps } from '../../ListItemAction.types';

type ListItemActionPrefixIconProps = Required<
  Pick<ListItemActionProps, 'prefixIcon'>
> &
  Pick<ListItemActionProps, 'subtitle' | 'size'>;

export const PrefixIcon: FC<ListItemActionPrefixIconProps> = ({
  prefixIcon,
  size,
  subtitle,
}) => {
  return React.cloneElement(prefixIcon, {
    size: size === 'medium' ? 24 : 18,
    className: st(classes.prefixIcon, { subtitle: Boolean(subtitle) }),
    'data-hook': DATA_HOOK.prefixIcon,
  });
};
